//컬럼 정의
export const _columns = [
  {
    field: "checkDate",
    headerName: "점검날짜",
    width: 130,
    renderCell: ({ row }) => {
      const value = String(row.checkDtm);
      if (value.length !== 14) return value;

      const yyyy = value.slice(0, 4);
      const MM = value.slice(4, 6);
      const dd = value.slice(6, 8);
      return `${yyyy}-${MM}-${dd}`;
    },
  },
  {
    field: "checkTime",
    headerName: "점검시각",
    width: 130,
    renderCell: ({ row }) => {
      const value = String(row.checkDtm);
      if (value.length !== 14) return value;

      const hh = value.slice(8, 10);
      const mm = value.slice(10, 12);
      const ss = value.slice(12, 14);
      return `${hh}:${mm}:${ss}`;
    },
  },
  {
    field: "monTargetNm",
    headerName: "서버명",
    width: 130,
  },
  {
    field: "chkRstCd",
    headerName: "상태",
    width: 100,
    renderCell: ({ value }) => {
      if (value === "1" || value === 1) return "OK";
      if (value === "2" || value === 2) return "FAIL";
      return value;
    },
  },
  {
    field: "cdName",
    headerName: "항목",
    width: 130,
    renderCell: ({ value }) => {
      return typeof value === "string" ? value.toLowerCase() : value;
    },
  },

  {
    field: "measVal",
    headerName: "측정값",
    width: 130,
  },
  {
    field: "alertSentYn",
    headerName: "알림전송",
    width: 100,
  },
  {
    field: "recipients",
    headerName: "수신자",
    width: 130,
    valueGetter: (params) => {
      const { recipients } = params.row;

      if (!recipients || !Array.isArray(recipients)) {
        return "";
      }

      const recvNames = recipients
        .map((recipient) => recipient.recvNm)
        .filter((name) => name);
      return recvNames.join(", ");
    },
  },
];

export const managerColumns = (columns) => {
  return columns.map((column) => ({
    ...column,
    headerClassName: "DataGridHeader",
  }));
};

export const columns5_6 = managerColumns(_columns);
